const state = {
  headerMenusList: [
    {
      href: '/dashboard',
      name: '首页',
    },
  ],
  clearPageName: '',
};

const mutations = {
  CHANGE_HEADER_MENUS_LIST (state, item) {
    if (state.headerMenusList.length === 0) {
      state.headerMenusList.push(item);
    } else {
      let result = false;
      result = state.headerMenusList.some(obj => {
        // 如果存在重复的路由 返回true
        if (item.name === obj.name) {
          obj.href = item.href;
          return true;
        }
      });
      if (!result) {
        state.headerMenusList.push(item);
      }
    }
  },
  DELETE_HEADER_MENUS_LIST (state, item) {
    // 带参数的url
    const queryItem = Object.fromEntries(new URLSearchParams(item.href.split('?')[1]));
    if (queryItem.id) {
      state.headerMenusList.forEach((el, index) => {
        let query = Object.fromEntries(new URLSearchParams(el.href.split('?')[1]));
        if (query.id === queryItem.id) {
          state.headerMenusList.splice(index, 1);
        }
      });
    } else {
      state.headerMenusList.forEach((el, index) => {
        if (el.href.split('?')[0] === item.href.split('?')[0]) {
          state.headerMenusList.splice(index, 1);
        }
      });
    }
  },
  CLEAR_MENUS (state) {
    state.headerMenusList = [];
  },
  CLEAR_PAGE (state, name) {
    state.clearPageName = name;
  },
};

const actions = {
  changeHeaderMenusList ({ commit }, item) {
    commit('CHANGE_HEADER_MENUS_LIST', item);
  },
  // 点击关闭选中最后一个页面
  chooseMenusList ({ commit }) {
    commit(
      'CHANGE_HEADER_MENUS_LIST',
      state.headerMenusList[state.headerMenusList.length - 1],
    );
  },
  deleteHeaderMenusList ({ commit }, item) {
    commit('DELETE_HEADER_MENUS_LIST', item);
  },
  clearMenus ({ commit }) {
    commit('CLEAR_MENUS');
  },
  clearPage ({ commit }, name) {
    commit('CLEAR_PAGE', name);
  },
  jumpAndClosePage ({ commit }, item) {
    if (item.close) {
      const nameList = item.close.href.split('/');
      const name = nameList[nameList.length - 1];
      commit('CLEAR_PAGE', name);
      commit('DELETE_HEADER_MENUS_LIST', item.close);
      commit('CHANGE_HEADER_MENUS_LIST', item.open);
    } else {
      commit('CLEAR_PAGE', '');
      commit('CHANGE_HEADER_MENUS_LIST', item.open);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
